import { TicketBody } from "./Ticket/TicketBody";
import { TicketHeader } from "./Ticket/TicketHeader";

export function Ticket({ data }) {
  return (
    <>
      <TicketHeader data={data.header} />
      <TicketBody
        messages={data.messages}
        status={data.header.status}
        id={data.header.id}
      />
    </>
  );
}
